/**
 * Interceptors are supposed to apply the same logic to all calls.  This enum exists as a way for
 * services to dictate a particular type of interceptor based on the types below.
 */
export enum InterceptorTypeEnum {
  EPM,
  EYEFINITY,
}
